var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:`swiper-button-prev ${_vm.defaultClass ? _vm.leftClass : ''}`,staticStyle:{"cursor":"pointer"}},[_vm._t("left")],2),_c('div',{class:`swiper-button-next ${_vm.defaultClass ? _vm.rightClass : ''}`,staticStyle:{"cursor":"pointer"}},[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }